export default __webpack_public_path__ + "static/media/ui_visual_indicator_book.b4afca96.png";